module.exports = __webpack_public_path__ + "static/img/box1_1.1b97fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LanguageTest/box1_1.png
// module id = lI0V
// module chunks = 23